import punjab from "./Assets/Images/punjab.jpg";
import sindh from "./Assets/Images/sindh.jpg";
import kpk from "./Assets/Images/KPK.jpg";
import balouchistan from "./Assets/Images/balochistan.jpg";
import kashmir from "./Assets/Images/kashmir.jpg";
import bg from "./Assets/Images/GB.jpg";

export const ImgCardData = [
  {
    id: 1,
    img: punjab,
    heading: "Punjab",
    detail: `Punjab is Pakistan's second largest province by area, and it is the most populated province, with rich culture & hitory.`,
    path: "/punjab",
  },
  {
    id: 2,
    img: sindh,
    heading: "Sindh",
    detail: `Punjab is Pakistan's second largest province by area, and it is the most populated province, with rich culture & hitory.`,
    path: "/sindh",
  },
  {
    id: 3,
    img: kpk,
    heading: "Khyber Pakhtunkhwa",
    detail: `Punjab is Pakistan's second largest province by area, and it is the most populated province, with rich culture & hitory.`,
    path: "/kpk",
  },
  {
    id: 4,
    img: balouchistan,
    heading: "Balouchistan",
    detail: `Punjab is Pakistan's second largest province by area, and it is the most populated province, with rich culture & hitory.`,
    path: "/balouchistan",
  },
  {
    id: 5,
    img: kashmir,
    heading: "Azad Kashmir",
    detail: `Punjab is Pakistan's second largest province by area, and it is the most populated province, with rich culture & hitory.`,
    path: "/azad-kashmir",
  },
  {
    id: 6,
    img: bg,
    heading: "Gilgit Baltistan",
    detail: `Punjab is Pakistan's second largest province by area, and it is the most populated province, with rich culture & hitory.`,
    path: "/gb",
  },
];
